import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'umss-rate-table',
  standalone: true,
  imports: [CurrencyPipe],
  templateUrl: './rate-table.component.html',
  styleUrl: './rate-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssRateTableComponent {
  @Input({ required: true }) baseRate!: number;
  @Input({ required: true }) differentialRate!: number;
  @Input() urgentRate?: number | null;

  get baseTotal(): number {
    return this.baseRate + this.differentialRate;
  }

  get urgentTotal(): number {
    return (this.urgentRate ?? 0) + this.differentialRate;
  }
}
